import { useAuth } from "@/modules/auth/hooks/useAuth";

import type { CardStylesConfig } from "../types/branding.types";

export function useOrgDesign(): CardStylesConfig | null {
  const { user } = useAuth();
  return user?.organization?.card_styles_config ?? null;
}
